import { GUARDIANS_GAME_RULES_INTRO } from "@/constants/guardiansGameRules"

export type WelcomeSlide = {
  id: string
  title: string
  lines: string[]
  highlight?: string
}

/** Краткий онбординг до входа; смысл совпадает с правилами виртуальной игры. */
export const WELCOME_SLIDES: WelcomeSlide[] = [
  {
    id: "intro",
    title: "Хранители",
    lines: [GUARDIANS_GAME_RULES_INTRO.subtitle],
    highlight:
      "Цель: качать карты, побеждать в дуэлях, поднимать рейтинг и эволюционировать карты до высших рангов.",
  },
  {
    id: "passport",
    title: "Твой профиль",
    lines: [
      "Цифровой паспорт — профиль, рейтинг, энергия и монеты.",
      "Академия — тесты и экзамены.",
      "Колода карт — стихии, стили, уровни и цвет рамки.",
    ],
  },
  {
    id: "cards",
    title: "Карты",
    lines: [
      "Стихии и стиль задают тактику в бою.",
      "Цвет рамки — от белого до красного: это прогресс и сила карты.",
      "Качай уровень за чакру, усиливай слияниями и бонусами.",
    ],
  },
  {
    id: "duel",
    title: "Дуэль за минуту",
    lines: [
      "Попадаешь в бой — RADAR или комната 1 на 1.",
      "До минуты тайно выбираешь одну карту; соперник делает то же.",
      "Сервер считает боевую силу — у кого больше, тот побеждает.",
    ],
    highlight: "За победу — очки рейтинга и монеты.",
  },
  {
    id: "city",
    title: "Город",
    lines: [
      "На карте — точки сканирования с наградами.",
      "QR на печатной карте ведёт в ту же виртуальную коллекцию.",
    ],
  },
  {
    id: "ready",
    title: "Готов играть?",
    lines: [
      "Войди по номеру телефона — за пару шагов настроим лигу и стартовые карты.",
    ],
  },
]
